/* Surface Impact's native cart errors without replacing its add/cart behavior. */
if (!customElements.get('smartjacket-powerbank-upsell')) {
  customElements.define('smartjacket-powerbank-upsell', class extends HTMLElement {
    connectedCallback() {
      this._abortController?.abort();
      this._abortController = new AbortController();
      const options = { signal: this._abortController.signal };
      this.addEventListener('submit', () => {
        const error = this.querySelector('[data-upsell-error]');
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
      }, options);
      this.addEventListener('cart:error', (event) => {
        const error = this.querySelector('[data-upsell-error]');
        if (error) {
          error.textContent = event.detail?.error || this.dataset.errorMessage || 'The power bank could not be added. Please try again.';
          error.hidden = false;
        }
      }, options);
    }
    disconnectedCallback() {
      this._abortController?.abort();
    }
  });
}
